import React from 'react';
import Logo from '../Logo';
import { NeuroMessageSet } from './NeuroMessages';

interface CompleteModalProps {
  messages: NeuroMessageSet;
  score: number;
}

export function CompleteModal({ messages, score }: CompleteModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl max-w-md w-full mx-4 p-8 text-center">
        <div className="mb-6">
          <Logo size="xl" variant="icon-only" />
        </div>

        <h2 className="text-2xl font-bold text-green-600 mb-4 font-baloo">
          Fantastic Focus!
        </h2>

        <p className="text-lg text-gray-700 mb-6 font-baloo">
          {messages.reward}
        </p>

        <div className="bg-gradient-to-r from-cyan-50 to-blue-50 rounded-xl p-4 mb-6">
          <div className="text-3xl font-bold text-blue-600 font-baloo">{score} points!</div>
          <div className="text-sm text-gray-600">Focus power increased!</div>
        </div>
      </div>
    </div>
  );
}
